import { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { CATEGORIES as STATIC_CATEGORIES, SHOP as STATIC_SHOP } from "@/data/products";
import { ITEMS as STATIC_ITEMS } from "@/data/items";
import { setShopRef } from "@/lib/sms";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SettingsContext = createContext(null);
const DEFAULT_DEALS_FALLBACK = [];

export const SettingsProvider = ({ children }) => {
  const [shop, setShop] = useState(STATIC_SHOP);
  const [categories, setCategories] = useState(STATIC_CATEGORIES);
  const [items, setItems] = useState(STATIC_ITEMS);
  const [deals, setDeals] = useState(DEFAULT_DEALS_FALLBACK);

  useEffect(() => {
    axios.get(`${API}/settings`).then((r) => {
      const s = r.data || {};
      if (s.phone) {
        const ns = { ...STATIC_SHOP, phone: s.phone, phoneDisplay: s.phoneDisplay, freeDeliveryThreshold: s.freeDeliveryThreshold };
        setShop(ns);
        setShopRef(ns);
      }
      if (s.categories) {
        const imgMap = s.category_images || {};
        const merged = STATIC_CATEGORIES.map((c) => ({
          ...c,
          blurb: s.categories[c.id]?.blurb || c.blurb,
          image: imgMap[c.id] ? `${API}/files/${imgMap[c.id]}` : c.image,
        }));
        setCategories(merged);
        const newItems = {};
        Object.keys(s.categories).forEach((k) => { newItems[k] = s.categories[k].items || []; });
        setItems({ ...STATIC_ITEMS, ...newItems });
      }
      if (Array.isArray(s.deals)) setDeals(s.deals);
    }).catch((err) => {
      console.warn("SettingsContext: failed to fetch /settings; using static fallback.", err);
    });
  }, []);

  // Memoised so consumers don't re-render on every parent render.
  const value = useMemo(() => ({ shop, categories, items, deals }), [shop, categories, items, deals]);

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext) || { shop: STATIC_SHOP, categories: STATIC_CATEGORIES, items: STATIC_ITEMS, deals: [] };
